import type { FlowThemeCardMotion } from '../../cardMotion';

const steppedEase = (steps: number) => (progress: number) => Math.min(1, Math.ceil(progress * steps) / steps);

/** A stepped, sprite-like drop with a few discrete frames instead of a smooth fade. */
export const pixelCardMotion = (): FlowThemeCardMotion => ({
  variants: {
    enter: () => ({ opacity: 0, y: -24 }),
    center: { opacity: 1, y: 0 },
    exit: () => ({ opacity: 0, y: 16 }),
  },
  transition: { duration: 0.42, ease: steppedEase(5) },
});
